import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import JoinMeeting from '@/components/JoinMeeting'
import ExitMeeting from '@/components/ExitMeeting'

Vue.use(Router)
const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/joinMeeting',
      name: 'JoinMeeting',
      component: JoinMeeting
    },
    {
      path: '/exitMeeting',
      name: 'ExitMeeting',
      component: ExitMeeting,
      props: true
    },
  ]
})
export default router

router.beforeEach((to, from, next) => {
  let currentURL = window.location.href
  let bla = currentURL.substring(currentURL.length - 2, currentURL.length)
  if (window.location.protocol !== 'https:' && !window.location.href.includes('localhost')) {
    window.location.protocol = 'https:'
    window.location.replace(window.location.href)
  } else if (bla === '#/') {
    if (navigator.appName === 'Microsoft Internet Explorer' || !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))) {
      next()
    } else {
      let url = new URL(window.location.href)
      if (url.searchParams.get('meetingID') && url.searchParams.get('name')) {
        if(url.searchParams.get('pin') && url.searchParams.get('pin') === 'required'){
          let newURL = currentURL.substring(0, currentURL.length - 2)
          newURL = newURL.replace('/?', '/#/?')
          window.location.replace(newURL)
        } else {
          let newURL = currentURL.substring(0, currentURL.length - 2)
          newURL = newURL.replace('/?', '/#/startMeeting?')
          window.location.replace(newURL)
        }
      } else if (url.searchParams.get('meetingID') || url.searchParams.get('branding')) {
        let newURL = currentURL.substring(0, currentURL.length - 2)
        newURL = newURL.replace('/?', '/#/?')
        window.location.replace(newURL)
      } else {
        next()
      }
    }
  } else {

    next()
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js